import { tokens } from "shared/components/Spor";
import styled from "styled-components";

export const HorizontalContainer = styled.form`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  margin: 0 1rem;
  gap: ${tokens.default.size.spacing[2]};
`;

export const DropdownAndInputGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 9px;
`;

// Name/phone number must never wrap - the header has a fixed height, so wrapped text would
// overflow it and overlap neighbouring elements.
export const ProfileDetails = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  white-space: nowrap;
`;

// Spor's size="sm" recipe sits the resting label ~2.5px above true center
// Ideally this should be fixed in the Spor library itself rather than applying a manual offset here.
export const CenteredLabelInput = styled.div`
  position: relative;
  display: inline-block;

  && [data-part="label"]:not([data-float]) {
    top: 10.5px;
  }
`;
